import './App.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';

import HomeOne from './components/pages/Home01';
import HomeTwo from './components/pages/Home02';
import AboutMain from './components/pages/About';
import CourseOne from './components/pages/CourseOne';
import CourseTwo from './components/pages/CourseTwo';
import CourseThree from './components/pages/CourseThree';
import CourseFour from './components/pages/CourseFour';
import CourseList from './components/pages/CourseList';

import CourseDetailsTwo from './components/pages/CourseDetailsTwo';

import InstructorOne from './components/pages/InstructorPage';


import Login from './components/pages/Login';
import Register from './components/pages/Register';

import ContactPage from './components/pages/ContactPage';
import BlogPageOne from './components/pages/BlogPageOne';
import Checkout from './components/pages/Checkout';
import LearningSpace from './components/layouts/home01/LearningSpace';
import Courses from './components/layouts/home01/Course';
import CourseDetails from './components/layouts/courseDetails/CourseDetails';
import DetailInstructor from './components/layouts/home01/DetailInstructor';
import EventPage from './components/pages/EventPage';


function App() {

  return (
    <BrowserRouter>
      {/* <ScrollToTop /> */}
      <Routes>

        <Route exact path={`${process.env.PUBLIC_URL + '/'}`} element={<HomeOne />} />
        <Route exact path={`${process.env.PUBLIC_URL + '/course'}`} element={<Courses />} />
        <Route exact path={`${process.env.PUBLIC_URL + '/course-details/:id'}`} element={<CourseDetails />} />
        <Route exact path={`${process.env.PUBLIC_URL + '/learning-space'}`} element={<LearningSpace />} />
        <Route exact path={`${process.env.PUBLIC_URL + '/instructor'}`} element={<DetailInstructor />} />
        <Route exact path={`${process.env.PUBLIC_URL + '/checkout'}`} element={<Checkout />} />

        <Route exact path={`${process.env.PUBLIC_URL + '/home-2'}`} element={<HomeTwo />} />
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/about'}`} element={<AboutMain/>}/> */}

        {/* <Route exact path={`${process.env.PUBLIC_URL + '/course-2'}`} element={<CourseTwo/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/course-3'}`} element={<CourseThree/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/course-4'}`} element={<CourseFour/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/course-list'}`} element={<CourseList/>}/> */}

        {/* <Route exact path={`${process.env.PUBLIC_URL + '/course-details-two/:id'}`} element={<CourseDetailsTwo/>}/> */}

        {/* <Route exact path={`${process.env.PUBLIC_URL + '/instructors'}`} element={<InstructorOne/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/login'}`} element={<Login/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/register'}`} element={<Register/>}/> */}

        {/* <Route exact path={`${process.env.PUBLIC_URL + '/contact'}`} element={<ContactPage/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/blog'}`} element={<BlogPageOne/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/contact'}`} element={<ContactPage/>}/> */}
        {/* <Route exact path={`${process.env.PUBLIC_URL + '/blog'}`} element={<BlogPageOne/>}/> */}
        <Route exact path={`${process.env.PUBLIC_URL + '/event'}`} element={<EventPage />} />

      </Routes>

    </BrowserRouter>
  );
}

export default App;
